import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Http from '@/utils/http';
import { Toast } from 'vant';
import 'vant/lib/index.css';
import './assets/css/base.css';
import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle'
import md5 from 'js-md5';
//小米自带方法
import * as miFn from "@/utils/mi";
//公共变量
Vue.prototype.$appID =100104;
Vue.prototype.$appKey ="VVl43bRcruK";
Vue.prototype.$sign =md5(`appid=100104|VVl43bRcruK`);
Vue.prototype.$baseUrl="https://a.huodong.mi.com"


Vue.prototype.$miFn = miFn;
Vue.prototype.$md5 = md5;
Vue.use(Toast);
Vue.use(Http);
axios.defaults.withCredentials=true;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
